export default {"src":"/_next/static/media/MouthSores.1d388b49.svg","height":75,"width":75,"blurWidth":0,"blurHeight":0};